import {
  OreButton,
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreStack,
  OreText,
} from '@edenredespana/oreneta'
import { useEffect } from 'react'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { createApiSignUpRepository } from '@/AutoEnrollment/infrastructure'
import { useSignUpController } from '@/AutoEnrollment/ui/hooks'
import { SignUpBasicForm } from '@/AutoEnrollment/ui/molecules'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const SignUpForm = (): JSX.Element => {
  const { t } = useTranslation()
  const { form, save } = useSignUpController(createApiSignUpRepository())
  const { formState } = form
  const watchEmail = form.watch('email')
  const watchEmailRepeat = form.watch('emailRepeat')

  useEffect(() => {
    if (formState.errors.emailRepeat && watchEmail === watchEmailRepeat) {
      form.clearErrors('emailRepeat')
    }
  }, [watchEmail, watchEmailRepeat, formState.errors.emailRepeat])

  return (
    <FormProvider {...form}>
      <form>
        <OreCardContainer>
          <OreCardWrapper>
            <OreStack space="2xlarge" placeContent="stretch">
              <SignUpBasicForm />
              <OreText>{t(formTranslation.common.requiredFields)}</OreText>
            </OreStack>
          </OreCardWrapper>
        </OreCardContainer>

        <OreDivider space="larger-top" />
        <OreStack direction="row" placeContent="end" space="medium">
          <OreButton
            disabled={!form.formState.isDirty}
            type="submit"
            onClick={form.handleSubmit(save)}
            size="small"
            category="primary"
            data-testid="signUp"
          >
            {t(formTranslation.common.buttons.saveAndContinue)}
          </OreButton>
        </OreStack>
      </form>
    </FormProvider>
  )
}
